import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import MaUTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import { useTable, useSortBy } from 'react-table'
import env_info from '../data/envInfo.json'

const columns = [
    {
      Header: 'QA Environment',
      columns: [
        {
          Header: 'Customer',
          accessor: 'customer',
        },
        {
          Header: 'Environment',
          accessor: 'environment',
        },
        {
          Header: 'Country',
          accessor: 'country',
        },        
        {
          Header: 'App Info',
          accessor: 'artifact',
        },
        {
          Header: 'Version',
          accessor: 'version',
        },
        {
          Header: 'Metadata Version',
          accessor: 'metadataVersion',
        },
        {
          Header: 'Host Info',
          accessor: 'server',
        },
        {
          Header: 'Status',
          accessor: 'Status',
        },
      ],
    },
  ];

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  },
  useSortBy
  )

  // Render the UI for your table
  return (
    <MaUTable {...getTableProps()}>
      <TableHead>
        {headerGroups.map(headerGroup => (
          <TableRow  {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <TableCell {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableHead>
      <TableBody {...getTableBodyProps()} >
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <TableRow hover {...row.getRowProps()}>
              {row.cells.map(cell => {
                return (
                  <TableCell {...cell.getCellProps()}>
                    {cell.render('Cell')}
                  </TableCell>
                )
              })}
            </TableRow>
          )
        })}
      </TableBody>
    </MaUTable>
  )
}

// const useStyles = makeStyles((theme) => ({
//   seeMore: {
//     marginTop: theme.spacing(3),
//   },
// }));

export default function QaEnvInfo() {
  return (
    <React.Fragment>
      <Title>Environment Info</Title>
      <Table columns={columns} data={env_info} />
    </React.Fragment>
  );
}
